<template>
    <div>
        <fieldset>
            <legend>
                <strong class="ma-2"> Employé </strong>
            </legend>
            <v-container fluid>
                <v-row dense>
                    <v-col cols="12">
                        <w-text-field
                            v-model="filter.code"
                            :label="$t('common.code')"
                        />
                    </v-col>
                    <v-col cols="12">
                        <w-text-field
                            v-model="filter.lastName"
                            :label="$t('common.lastname')"
                        />
                    </v-col>
                    <v-col cols="12">
                        <w-text-field
                            v-model="filter.firstName"
                            :label="$t('common.firstname')"
                        />
                    </v-col>
                    <v-col cols="12">
                        <organizational-chart-select
                                v-model="filter.organizationalchartId"
                                label="Organigramme"
                        />
                    </v-col>
                    <v-col cols="12">
                        <str-occupation-autocomplete
                            v-model="filter.occupationId"
                            label="Fonction"
                       />
                    </v-col>
                    <v-col cols="12">
                        <w-data-select-autocomplete
                                v-model="filter.workplaceId"
                                label="Lieu de Travail"
                                type="WORKER_WORKPLACE"
                       />
                    </v-col>
                    <v-col cols="12">
                        <w-data-select-autocomplete
                                v-model="filter.companyId"
                                label="Société de déclaration"
                                type="WORKER_COMPANY"
                        />
                    </v-col>
                    <v-col cols="12">
                        <w-data-select-autocomplete
                                v-model="filter.stateId"
                                label="Etat"
                                type="WORKER_STATE"
                       />
                    </v-col>
                    <v-col cols="12">
                        <w-enum-select
                            v-model="filter.phase"
                            :items="workerPhases"
                            :label="$t('worker.status')"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </fieldset>
    </div>
</template>

<script>
import useSharedSelectData from "@/use/SharedSelectData";

export default {
    props: {
        filter: {
            type: Object,
            required: true,
        },
    },
    setup() {
        const {workerPhases} = useSharedSelectData();

        return {
            workerPhases,
        }
    }
};
</script>